function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("circle", {
  cx: 33,
  cy: 33,
  r: 33,
  fill: "#b9f4bc"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M35 33l13.992-8.078v16.156zm-1-17.97l14.03 8.137-14.03 8.1V15.03zm-16.03 8.137L32 15.03v16.238zM31 33l-13.992 8.078V24.922zm1 17.97l-14.03-8.137 14.03-8.1V50.97zm16.03-8.137L34 50.97V34.732z",
  fill: "#1bb978",
  opacity: 0.4
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M33 12a3 3 0 11-3 3 3 3 0 013-3zm0 36a3 3 0 11-3 3 3 3 0 013-3zm18.187-25.5a3 3 0 11-4.1-1.1 3 3 0 014.1 1.1zm-31.177 18a3 3 0 11-4.1-1.1 3 3 0 014.1 1.1zm31.177 3a3 3 0 11-1.1-4.1 3 3 0 011.1 4.1zm-31.177-18a3 3 0 11-1.1-4.1 3 3 0 011.1 4.1zM33 30a3 3 0 11-3 3 3 3 0 013-3z",
  fill: "#1bb978"
});

function SvgSharing(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 66,
    height: 66
  }, props), _ref, _ref2, _ref3);
}

export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI2NiIgaGVpZ2h0PSI2NiIgdmlld0JveD0iMCAwIDY2IDY2Ij48Y2lyY2xlIGN4PSIzMyIgY3k9IjMzIiByPSIzMyIgZmlsbD0iI2I5ZjRiYyIvPjxwYXRoIGQ9Ik0zNSAzM2wxMy45OTItOC4wNzh2MTYuMTU2em0tMS0xNy45N2wxNC4wMyA4LjEzNy0xNC4wMyA4LjFWMTUuMDN6bS0xNi4wMyA4LjEzN0wzMiAxNS4wM3YxNi4yMzh6TTMxIDMzbC0xMy45OTIgOC4wNzhWMjQuOTIyem0xIDE3Ljk3bC0xNC4wMy04LjEzNyAxNC4wMy04LjFWNTAuOTd6bTE2LjAzLTguMTM3TDM0IDUwLjk3VjM0LjczMnoiIGZpbGw9IiMxYmI5NzgiIG9wYWNpdHk9Ii40Ii8+PHBhdGggZD0iTTMzIDEyYTMgMyAwIDEgMS0zIDMgMyAzIDAgMCAxIDMtM3ptMCAzNmEzIDMgMCAxIDEtMyAzIDMgMyAwIDAgMSAzLTN6bTE4LjE4Ny0yNS41YTMgMyAwIDEgMS00LjEtMS4xIDMgMyAwIDAgMSA0LjEgMS4xem0tMzEuMTc3IDE4YTMgMyAwIDEgMS00LjEtMS4xIDMgMyAwIDAgMSA0LjEgMS4xem0zMS4xNzcgM2EzIDMgMCAxIDEtMS4xLTQuMSAzIDMgMCAwIDEgMS4xIDQuMXptLTMxLjE3Ny0xOGEzIDMgMCAxIDEtMS4xLTQuMSAzIDMgMCAwIDEgMS4xIDQuMXpNMzMgMzBhMyAzIDAgMSAxLTMgMyAzIDMgMCAwIDEgMy0zeiIgZmlsbD0iIzFiYjk3OCIvPjwvc3ZnPg==";
export { SvgSharing as ReactComponent };